import React from "react";
import { Navigate } from "react-router-dom";
import { storageService } from "Services/storage_service";
import { RUTAS } from "rutas";
import { ROLES } from "Constantes/constants";

export const RutaPublica = ({ children }) => {
  const user = storageService.getItem("user");
  const isAuthenticated = Boolean(user?.token);

  if (isAuthenticated && user.idRol !== ROLES.NO_CLIENTE.ID) {
    return <Navigate to={RUTAS.ADMIN_HOME} replace />;
  }

  return children;
};
